export const TELEGRAM_BOT_URL = `${import.meta.env.MODE === 'test' ? 'https://t.me/arhiassistant_stage_bot' : 'https://t.me/ARHIASSISTANT_bot'}`
